<!--
* UIID: UI-DLB-SRM-120
* UI Name: Map List
* Modify Date: 2020/04/15
-->
<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    :options="options"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display"
  >
    <!-- [S]  Popup title-->
    <template v-slot:title>
      <v-card-title
        class="headline white--text"
        primary-title
      >{{$t('lbl.srmListManagement.mapperList.page_header')}}</v-card-title>
    </template>
    <template v-slot:button-close>
      <v-btn small text icon @click="removeDialog1">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <!-- [E]  Popup title-->
    <v-card-text class="data-section pa-0 pr-8 pl-8 mr-0">
      <!-- [S]  Data Section-->
      <v-row class="ma-0 map-pb-search">
        <v-col cols="5" class="pa-0" v-if="customerSelect"></v-col>
        <v-col cols="8" class="pa-0" v-else></v-col>
        <v-col cols="3" class="map-popup-locked" v-if="customerSelect">
          <v-label>Company</v-label>
          <div class="map-dv-select-company">
            <v-select
              :items="companyList"
              v-model="filterItems.comp"
              @change="filterMapList"
              height="30"
              solo
              dense
            ></v-select>
          </div>
        </v-col>
        <v-col cols="1" class="map-popup-locked">
          <v-label>Locked</v-label>
          <div class="map-dv-select-locked">
            <v-select
              :items="lockedItems"
              v-model="filterItems.locked"
              @change="filterMapList"
              height="30"
              solo
              dense
            ></v-select>
          </div>
        </v-col>
        <v-col cols="3" class="pt-0 pb-0 pr-0 map-search">
          <v-text-field
            v-model="filterItems.search"
            @input="filterMapList"
            @click:append="filterMapList"
            @keyup.enter="filterMapList"
            class="search-matched-map-list-button custom-form-component search-button"
            outlined
            dense
            solo
            hide-details
            placeholder="Search"
            append-icon="fas fa-search"
            height="30"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12" class="pt-0 pr-0 pb-0 pl-0">
          <v-data-table
            :headers="SummDataList.headers"
            :items="mapList"
            :items-per-page="-1"
            :hide-default-footer="true"
            :disable-sort="true"
            class="map-list-table pb-0 popup-list-table"
            fixed-header
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.ROWID">
                  <td class="select-col">
                    <input
                      @click="inputSelectedMap(item)"
                      :checked="item.SELE_YN == 'Y'"
                      type="radio"
                      name="select-map"
                    />
                  </td>
                  <td class="map-name-col">{{ item.MAP_NAME }}</td>
                  <td class="locked-col">
                    <v-icon
                      v-if="item.MAP_MAPP_CHKIN_YN === 'Y' "
                      small
                      @click.native="releaseLockedMap(item,'MAPP')"
                    >fas fa-check-square</v-icon>
                    <v-icon v-if="item.MAP_MAPP_CHKIN_YN === 'N' " small>far fa-window-close</v-icon>
                  </td>
                  <td class="mapper-col">{{ item.MAPPER_NAME }}</td>
                  <td class="type-col text-center">
                    <a class="link-file-text" @click="openMapperVersion(item)">{{item.MAPP_VER}}</a>
                  </td>
                  <td class="locked-col">
                    <v-icon
                      v-if="item.MAP_SCAN_CHKIN_YN === 'Y' "
                      small
                      @click.native="releaseLockedMap(item,'SCAN')"
                    >fas fa-check-square</v-icon>
                    <v-icon v-if="item.MAP_SCAN_CHKIN_YN === 'N' " small>far fa-window-close</v-icon>
                  </td>
                  <td class="scanner-col">{{ item.SCANNER_NAME }}</td>
                  <td class="type-col text-center">
                    <a class="link-file-text" @click="openScannerVersion(item)">{{item.SCAN_VER}}</a>
                  </td>
                  <td class="cust--col" v-if="customerSelect">{{ item.MST_CUST_ID }}</td>
                  <td class="flat-file-col">{{ item.FFL_FILE_NAME }}</td>
                  <td class="mapping-defenition-col">{{ item.MPD_FILE_NAME }}</td>
                  <td class="apply-srm-col">
                    <a @click.stop="showSRMList(item,$event)">{{ item.CNT }}</a>
                  </td>
                  <v-overlay
                    :absolute="absolute"
                    :value="overlay"
                    :dark="$vuetify.theme.dark"
                    class="tableOverlay"
                  >
                    <v-data-table
                      :headers="SRMList.headers"
                      :items="srmData"
                      :hide-default-footer="true"
                      :disable-sort="true"
                      :hide-default-header="true"
                      :fixed-header="true"
                      class="overlay-table"
                    >
                      <template v-slot:header="{ props: { headers } }">
                        <thead>
                          <tr @click.stop="closeTbOverlay">
                            <th class="center">{{ headers[0].text }}</th>
                            <th class="center">{{ headers[1].text }}</th>
                            <th class="center">{{ headers[2].text }}</th>
                          </tr>
                        </thead>
                      </template>
                      <template v-slot:body="{ items }">
                        <tbody>
                          <tr v-for="item in items" :key="item.id" @click.stop="closeTbOverlay">
                            <td class="sender-col">{{ item.SRM_SNDR }}</td>
                            <td class="receiver-col">{{ item.SRM_RCVR }}</td>
                            <td class="message-col">{{ item.SRM_MSG_ID }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-data-table>
                  </v-overlay>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <!-- [E]  Data Section-->
    </v-card-text>
    <v-divider class="ml-0 mr-0 divder-popup" inset></v-divider>
    <v-row class="ml-0 mr-0">
      <v-col class="button-col action-col" lg="12">
        <div class="btn-form-control text-right mr-4">
          <v-btn class="btn btn-delete" @click="removeDialog1">{{$t('btn.common.close')}}</v-btn>
        </div>
      </v-col>
    </v-row>
    <!-- <v-divider class="ml-0 mr-0 divder-popup" inset></v-divider>
    <v-row class="ma-0 pt-0">
      <v-col class="pa-0 text-left" cols="3"></v-col>
      <v-col class="pa-0" cols="9">
        <v-row class="ma-0 btn-pt-10">
          <v-spacer></v-spacer>
          <v-col class="pa-0 text-right" cols="6">
            <v-btn class="ma-0 btn-style btn-delete" tile dark @click="removeDialog1">
              {{$t('btn.common.close')}}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>-->
  </dialog-drag>
</template>

<script>
/* globals Store */

import DialogDrag from "@/vue-dlb/components/vue-dialog-drag.vue";
import { mapState } from "vuex";
import $ from "jquery";
import cfg from "@/vue-caas/config/config.js";
import IconSvg from "@/vue-caas/components/IconBase.vue";

// import {
//   showSuccessMessage,
//   showErrorMessage,
//   showProgress,
//   hideProgress,
//   alertSuccess,
//   closeAlert
// } from "@/vue-dlb/utils/sys-util.js";

export default {
  components: {
    DialogDrag,
    IconSvg,
  },
  name: "maplist-dialog",
  // props: ['id', 'title', 'options', 'eventCb','selectFile', 'closeDialog', 'dragStart', 'dragEnd', 'queryList','fileSelected'],
  props: {
    id: String,
    title: String,
    options: Object,
    eventCb: Function,
    selectFile: Function,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    queryList: Array,
    fileSelected: String,
  },
  computed: {
    ...mapState("srmlist", {
      mapList: "mapList",
      appliedList: "appliedList",
    }),
  },
  data: () => ({
    overlay: false,
    absolute: false,
    isActive: true,
    selected_map: "",
    mapData: [],
    userRow: "admin",
    customerSelect: false,
    search: "",
    srmData: "",
    arrLayoutDialog: [],
    dialogs: [],
    dialogId: 1,
    mapperVersionHistoryItem: null,
    masterSearchItems: {
      header: ["ADMIN_YN", "CUST_ID", "LOCK_YN", "MAP_PRCS_NO"],
      data: [
        {
          ADMIN_YN: "",
          CUST_ID: "",
          LOCK_YN: "",
          MAP_PRCS_NO: "",
        },
      ],
    },
    filterItems: {
      comp: "",
      locked: "",
      search: "",
    },
    SummDataList: {
      headers: [
        { text: "Select", value: "USE_YN" },
        { text: "Map Name", value: "MAP_NAME" },
        { text: "Locked", value: "MAP_MAPP_CHKIN_YN" },
        { text: "Mapper", value: "MAPPER_NAME" },
        { text: "Version", value: "MAPP_VEER" },
        { text: "Locked", value: "MAP_SCAN_CHKIN_YN" },
        { text: "Scanner", value: "SCANNER_NAME" },
        { text: "Version", value: "SCAN_VER" },
        { text: "Company ID", value: "MST_CUST_ID" },
        { text: "FlatFile Layout", value: "FFL_FILE_NAME" },
        { text: "Mapping Definition", value: "MPD_FILE_NAME", width: "200px" },
        { text: "Applied SRM", value: "CNT", width: "200px" },
      ],
    },
    SRMList: {
      headers: [
        { text: "Sender", value: "SRM_SNDR" },
        { text: "Receiver", value: "SRM_RCVR" },
        { text: "Message", value: "SRM_MSG_ID" },
      ],
      dataItems: [],
    },
    lockedItems: [
      { text: "All", value: "" },
      { text: "Y", value: "Y" },
      { text: "N", value: "N" },
    ],
    customerItems: [
      { text: "All", value: "" },
      { text: "Customer", value: "ENDUSER" },
      { text: "Admin", value: "ADMIN" },
    ],
    releaseLockItems: {
      header: ["MAP_KIND", "MAP_PRCS_NO", "LOCK_YN"],
      data: [
        {
          MAP_KIND: "",
          MAP_PRCS_NO: "",
          LOCK_YN: "N",
        },
      ],
    },
    companyList: [{ text: "All", value: "" }],
  }),

  methods: {
    getCompanyList() {
      this.$store.dispatch("getCompanyList").then(() => {
        this.$store.getters.companies.forEach((item) => {
          this.companyList.push({
            text: item.compNm,
            value: item.compId,
          });
        });
      });
    },
    inputSelectedMap(item) {
      this.$emit("inputSelectedMap", { item, selectItem: this.options.item });
      this.removeDialog1(this);
      this.selectFile(item);
    },
    openMapperVersion(itemRow) {
      this.$emit("openMapperVersion", itemRow);
    },
    openScannerVersion(itemRow) {
      this.$emit("openScannerVersion", itemRow);
    },
    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = "Dialog " + id;
      let options = { left: 30 * this.dialogId, top: 30 * this.dialogId, item };
      return { id, name, type, options };
    },
    removeDialog(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
    removeDialog1(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      let index = this.findDialog(obj.id);
      this.selected = this.dialogs[index];
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    // dialogDragEnd (obj) {
    //   let index = this.findDialog(obj.id)
    //   this.$set(this.dialogs[index].options, 'left', obj.left)
    //   this.$set(this.dialogs[index].options, 'top', obj.top)
    // },
    showSRMList(exData, e) {
      let left = e.clientX;
      if (this.overlay === true) {
        this.overlay = false;
      } else {
        let listResult = [];
        listResult = this.appliedList.filter((item) => {
          if (item.MAP_PRCS_NO === exData.MAP_PRCS_NO) {
            return true;
          }
          return false;
        });
        this.srmData = listResult;
        let top = e.clientY;
        $(".tableOverlay").css("top", top);
        $(".tableOverlay").css("left", left);
        this.overlay = true;
      }
    },
    closeTbOverlay() {
      this.overlay = false;
    },
    releaseLockedMap(item, type) {
      this.releaseLockItems.data[0].MAP_KIND = type;
      this.releaseLockItems.data[0].MAP_PRCS_NO = item.MAP_PRCS_NO;
      Store.dispatch("map/updateLock", this.releaseLockItems).then(() => {
        this.queryMapList();
      });
    },
    queryMapList() {
      //[2020-04-17] apply by CLV: Apply srmlist/queryMapList api
      console.log("--------- getSummaryList ----------");
      this.masterSearchItems.data[0].ADMIN_YN = $cookies.get("used-repo");
      //mod by April
      // if($cookies.get('comp-id') == cfg.provider) { //only available for CLT Company, Super Admin
      if (this.customerSelect) {
        //only available for CLT Company, Super Admin
        this.masterSearchItems.data[0].CUST_ID = "ALL"; // TBD - April. After get API from CASS to search customer, Change here.
      } else {
        this.masterSearchItems.data[0].CUST_ID = $cookies.get("comp-id");
      }

      this.masterSearchItems.data[0].LOCK_YN = "";
      this.masterSearchItems.data[0].MAP_PRCS_NO = this.options.item.MAP_PRCS_NO;

      Store.dispatch("srmlist/queryMapList", this.masterSearchItems).then(
        () => {
          console.log("--------- Finished to process ----------");
          console.log(this.mapList);
          console.log(this.appliedList);
          this.mapData = this.mapList;
        }
      );
    },
    filterMapList() {
      Store.commit("srmlist/SET_MAP_FILTER", this.filterItems);
    },
  },
  created() {
    const userId = $cookies.get("user-id").split("@");

    if (userId[1] == cfg.provider) {
      this.customerSelect = true;
      this.getCompanyList();
    } else {
      this.SummDataList.headers.splice(8, 1);
    }

    this.queryMapList();
    // if($cookies.get('comp-id') == cfg.provider) {
    //     this.customerSelect = true;
    // }
    if (this.fileSelected !== undefined && this.fileSelected !== null) {
      this.selected_map = this.fileSelected;
    }
  },
  mounted() {
    $("body").click((event) => {
      this.closeTbOverlay();
    });
  },
  watch: {},
};
</script>

<style>
/* // 2021.10.20 203728  set height auto */
.maplist-layout-dialog {
  width: 1300px !important;
  height: auto !important;
}
/* Remove unuse code
.dialog-drag.maplist-layout-dialog .dialog-body{
    background-color: white;
}
.maplist-layout-dialog .dialog-header{
    background-color: #253C51;
    height: 60px;
}
.text-custom{
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
}
.locked-icon{
    font-size: 11px !important;
    margin-bottom: 6px;
    color: #C4C4C4 !important;
    border: 1px solid;
    padding-left: 2px;
    padding-right: 2px;
}
*/
.maplist-layout-dialog .dialog-body .v-card__text.data-section {
  padding: 20px 15px 15px 15px !important;
  background: #fafcff;
  border: 1px solid #f0f7fb;
  box-sizing: border-box;
  border-radius: 3px;
}
/* .map-list-table .v-card__title.headline.white--text{
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 25px;
    line-height: 29px;
    display: flex;
    align-items: center;
} */
.map-list-table thead {
  background: #e4e6e8 !important;
  border: 1px solid #d0d4dd !important;
}
.map-list-table thead tr th.text-start {
  color: #000000 !important;
  border-right: 1px solid #e0e6f2;
  text-align: center !important;
  height: 25px !important;
}
.map-list-table td {
  border-right: 1px solid #d0d4dd;
  border-bottom: 1px solid #d0d4dd;
  text-align: center !important;
  font-size: 12px;
}
/* .theme--dark .map-list-table th{
  border: 0px solid #D0D4DD !important;
  font-size: 12px;
} */
.map-list-table .v-data-table__wrapper {
  overflow-y: auto;
  max-height: 207px;
  height: 207px;
}
.popup-list-table .v-overlay .v-data-table__wrapper {
  overflow-y: auto;
  height: 100%;
  max-height: 150px;
}
.map-list-table thead th span {
  font-size: 11px !important;
}
.map-list-table a {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 15px;
  text-decoration: underline;
  color: #0082ba !important;
}
.srm-list-overlay-table .srmDialogHeader {
  color: black !important;
  font-size: 10px !important;
  line-height: 14px;
  text-align: center !important;
}
.srmOverlay {
  bottom: 83px;
  right: 15px;
  top: unset;
  left: unset;
  height: 94px;
  width: 300px;
}
.srmOverlay .v-overlay__content {
  position: absolute;
  top: 0;
}
.srm-list-overlay-table {
  background-color: #ffffff !important;
  color: black !important;
  height: auto;
  width: 300px;
  overflow-x: hidden;
}
.map-list-table .srm-list-overlay-table .v-data-table__wrapper {
  overflow-y: auto;
  height: 100%;
  max-height: 93px;
  width: 300px;
}
.map-list-table .srm-list-overlay-table .v-data-table__wrapper table {
  height: 100%;
}
.srm-list-overlay-table td.sender-col,
.srm-list-overlay-table td.receiver-col,
.srm-list-overlay-table td.message-col {
  font-size: 10px !important;
  line-height: 14px !important;
  border: 1px solid #d0d4dd;
  text-align: center !important;
}
.srmOverlay .v-overlay__scrim {
  opacity: 0 !important;
}
.map-dv-select
  > .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot {
  padding: 0px;
  width: 125px;
  margin: 0px;
  border: 1px solid #d4d5d7;
  height: 25px;
  border-radius: 1px;
  min-height: 25px;
  box-sizing: border-box;
  box-shadow: none;
}
.map-dv-select
  .theme--dark.v-text-field--solo
  > .v-input__control
  > .v-input__slot,
.map-dv-select-locked
  .theme--dark.v-text-field--solo
  > .v-input__control
  > .v-input__slot {
  background-color: #3b3e49 !important;
}

.map-dv-select
  .theme--dark.v-text-field--solo
  > .v-input__control
  > .v-input__slot,
.map-dv-select-company
  .theme--dark.v-text-field--solo
  > .v-input__control
  > .v-input__slot {
  background-color: #3b3e49 !important;
}

.map-dv-select .v-text-field__details {
  max-height: 0px !important;
  min-height: 0px !important;
  margin: 0px !important;
  padding: 0px;
}
.map-dv-select .v-input__control {
  min-height: 25px !important;
}
.map-dv-select {
  float: right;
  padding: 0px 7px 0px 4px;
}
.map-dv-select-locked
  > .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot {
  padding: 0px;
  width: 65px;
  margin: 0px;
  border: 1px solid #d4d5d7;
  height: 25px;
  border-radius: 1px;
  min-height: 25px;
  box-sizing: border-box;
  box-shadow: none;
}

.map-dv-select-company
  > .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot {
  padding: 0px;
  width: 200px;
  margin: 0px;
  border: 1px solid #d4d5d7;
  height: 25px;
  border-radius: 1px;
  min-height: 25px;
  box-sizing: border-box;
  box-shadow: none;
}

.map-dv-select-locked .v-text-field__details {
  max-height: 0px !important;
  min-height: 0px !important;
  margin: 0px !important;
  padding: 0px;
}
.map-dv-select-company .v-text-field__details {
  max-height: 0px !important;
  min-height: 0px !important;
  margin: 0px !important;
  padding: 0px;
}

.map-dv-select-locked .v-input__control {
  min-height: 25px !important;
}
.map-dv-select-company .v-input__control {
  min-height: 25px !important;
}

.map-dv-select-locked {
  float: right;
  padding: 0px 10px 0px 4px;
}
.map-dv-select-company {
  float: right;
  padding: 0px 10px 0px 4px;
}
/* .maplist-layout-dialog ::placeholder {
  color: #DFE1E5 !important;
  opacity: 1;
} */
.v-icon.notranslate.fa.fa.fa.fa-search.theme--light {
  color: #dfe1e5 !important;
}
.map-pb-search {
  padding-bottom: 5px;
}
.map-popup-info {
  padding: 0px 0px 0px 100px;
  display: flex;
}
.map-popup-info .v-label {
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  top: 0px;
  color: #000000 !important;
}
.map-popup-locked .v-label {
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  top: 0px;
  color: #000000 !important;
}
.map-popup-locked {
  padding: 0px 0px 0px 0px;
  display: flex;
}
/* .locked-active{
  font-weight: bold
} */
.map-search {
  padding-left: 10px !important;
}
.map-list-table .select-col,
.map-list-table .locked-col {
  padding-top: 5px !important;
}
.map-list-table .map-name-col,
.map-list-table .mapper-col,
.map-list-table .scanner-col,
.map-list-table .customer-col,
.map-list-table .flat-file-col,
.map-list-table .mapping-defenition-col {
  text-align: left !important;
}
.map-list-table .map-name-col {
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  color: #000000;
}
.map-dv-select .v-select__selection--comma,
.map-dv-select-locked .v-select__selection--comma {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  padding-left: 8px;
}

.map-dv-select .v-select__selection--comma,
.map-dv-select-company .v-select__selection--comma {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  padding-left: 8px;
}
.maplist-layout-dialog .theme--dark.v-data-table thead tr:last-child th {
  background-color: #595b64 !important;
  color: white !important;
}
/* Theme light */
.theme--light .map-list-table td {
  background-color: #ffffff;
}
.theme--light .map-list-table thead tr:first-child th {
  border-right: 1px solid #d0d4dd;
  border-top: 1px solid #d0d4dd;
  font-size: 12px;
}
.theme--light .map-list-table thead tr:first-child th:first-child {
  border-right: 1px solid #d0d4dd;
  border-bottom: 1px solid #d0d4dd !important;
  border-left: 1px solid #d0d4dd !important;
}
.theme--light .v-data-table.map-list-table {
  background-color: transparent !important;
  color: black !important;
  padding-bottom: 20px;
  height: auto;
}
.theme--light.v-data-table.v-data-table--fixed-header.map-list-table thead th {
  background: #E0E6F3 !important;
}
/* Theme dark */
.theme--dark .maplist-layout-dialog .dialog-body {
  background-color: #3b3e49;
  border-left: none !important;
}
.theme--dark .maplist-layout-dialog label.v-label {
  color: #bbbbbb !important;
}
.theme--dark
  .v-text-field.search-matched-map-list-button
  .v-input__control
  .v-input__slot {
  background-color: #3b3e49 !important;
}
.theme--dark
  .search-matched-map-list-button.custom-form-component
  .v-input__slot
  .v-text-field__slot
  input {
  background-color: #3b3e49 !important;
}
.theme--dark
  .map-dv-select
  > .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot {
  border: none;
}
.theme--dark
  .map-dv-select-locked
  > .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot {
  border: none;
}
.theme--dark
  .map-dv-select-company
  > .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot {
  border: none;
}
.theme--dark
  .maplist-layout-dialog
  .search-matched-map-list-button.custom-form-component
  .v-input__slot
  .v-text-field__slot
  input,
.theme--dark
  .maplist-layout-dialog
  .search-matched-map-list-button.custom-form-component
  .v-input__slot
  .v-text-field__slot
  input::placeholder {
  color: #bbbbbb !important;
}
.theme--dark .map-list-table .map-name-col,
.theme--dark .map-list-table .customer-col {
  color: #bbbbbb;
}
.theme--dark .v-data-table.map-list-table {
  background-color: transparent !important;
  color: #bbbbbb;
}
.theme--dark .map-list-table td {
  background-color: #191a21;
}
.theme--dark .maplist-layout-dialog .dialog-body .v-card__text.data-section {
  border: none;
  background-color: #25272e;
}
</style>